import { LoggerFactory } from '@cvent/logging/LoggerFactory';
import { useMutation } from '@apollo/client';
import { User } from '@state/index';

const LOG = LoggerFactory.create('useCompliance');

let complianceUpdated = false;
export interface UseComplianceProps {
  globalPrivacyControl: boolean;
  ccpa: string;
  isGPCEnabled: boolean;
  doNotSell: boolean;
  attendeeId: string;
  contactId: string;
}

/**
 * Hook for updating attendee CCPA Compliance
 */
const useCompliance = ({
  globalPrivacyControl,
  ccpa,
  isGPCEnabled,
  doNotSell,
  attendeeId,
  contactId
}: UseComplianceProps) => {
  const [updateAttendeeCompliance] = useMutation(User.Mutations.UPDATE_ATTENDEE_COMPLIANCE);

  const executeDoNotSellRequest = async () => {
    LOG.debug(`Updating attendee compliance for contact: ${contactId}`);
    complianceUpdated = true;

    const response = await updateAttendeeCompliance({
      variables: {}
    });

    if (response.errors) {
      LOG.error(`Error trying to update compliance for attendee: ${attendeeId}`, response.errors);
    }
  };

  const requestDoNotSell =
    globalPrivacyControl && // app feature enabled
    ccpa && // ccpa is enabled for the event
    isGPCEnabled && // sec-gpc header is enabled
    !doNotSell && // has not already submitted a request in the past
    !complianceUpdated; // has not already submitted a request in the current visit

  if (requestDoNotSell) {
    executeDoNotSellRequest();
  }
};

export default useCompliance;
